import Queries from '../../../../../../../utils/API/Queries';
import { setSelectedRegion } from '../../../../../../../redux/store/user/actions';

class CreatePartnerHelper {
	static createPartner = async (partnerName, selectedRegion, regionConfig, client, hideModal, showInfoMessage) => {
		if (partnerName === '') {
			showInfoMessage('Please enter a partner name.');
			return;
		}

		let { partners = [] } = regionConfig.coldwellPackages;
		partners.push({
			name: partnerName,
			packages: []
		});

		let variables = {
			id: regionConfig.id,
			coldwellPackages: {
				...regionConfig.coldwellPackages,
				partners
			}
		};

		const response = await client
			.mutate({
				mutation: Queries.UPDATE_REGION_CONFIG,
				variables
			})
			.catch((error) => {
				showInfoMessage(error.message);
			});
		const { updateRegionConfig } = response['data'];
		if (updateRegionConfig) {
			selectedRegion.regionConfig = updateRegionConfig;
			showInfoMessage('Created partner.');
			setSelectedRegion(selectedRegion);
			hideModal();
		} else {
			showInfoMessage('Error creating partner.');
			hideModal();
		}
	};

	static isPartnerNameValid = (partnerName) => {
		return partnerName && partnerName.length > 2;
	};
}

export default CreatePartnerHelper;
